import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Sorting = {
  key: string;
  order: "asc" | "desc";
};

type SortingState = {
  sortingData: Sorting | null;
};

const initialState: SortingState = {
  sortingData: {
    key: "",
    order: "desc",
  },
};

const sortingSlice = createSlice({
  name: "sorting",
  initialState,
  reducers: {
    setSorting: (state, action: PayloadAction<Sorting | null>) => {
      state.sortingData = action.payload;
    },
    clearSorting: (state) => {
      state.sortingData = null;
    },
  },
});

export const { setSorting, clearSorting } = sortingSlice.actions;
export default sortingSlice.reducer;
